var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuSkill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96484 11.0833L17.0898 7.12499L9.96484 3.16666L2.83984 7.12499L9.96484 11.0833ZM9.96484 11.0833L14.8408 8.37444C15.2704 9.4577 15.5065 10.6388 15.5065 11.8749C15.5065 12.4302 15.4589 12.9742 15.3675 13.5033C13.3012 13.7042 11.4287 14.5672 9.96484 15.8773C8.50102 14.5672 6.62853 13.7043 4.56221 13.5033C4.47081 12.9742 4.42318 12.4301 4.42318 11.8749C4.42318 10.6387 4.65929 9.45768 5.08887 8.37444L9.96484 11.0833ZM6.79818 15.8333V9.89582L9.96484 8.13656",
    stroke: "#CBD5E1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSkill);
export default __webpack_public_path__ + "static/media/menu-skill.664dfda1db7514f60c7c7441160ae942.svg";
export { ForwardRef as ReactComponent };